import type { Text } from 'pixi.js';
import applyDisplayObjectProps from './applyDisplayObjectProps';
import type { TextProps } from './DisplayObjectProps';
import applyAnchor from './apply/applyAnchor';

export default function applyTextProps<T extends Text>(text: T, props: TextProps): T {
  if (text.destroyed) return text;

  applyDisplayObjectProps(text, props);
  applyAnchor(text, props.anchor);

  if (props.tint !== undefined) text.tint = props.tint;
  if (props.text !== undefined) text.text = props.text;
  if (props.fill !== undefined) text.style.fill = props.fill;

  return text;
}
